import { useAppDispatch } from '../../redux/hooks';
import { setQuickAccessDictionarySetting } from '../../redux/slices/userSettings';
import { EntityTabType } from './DictionaryTabs/types';
import { useUserSettingsSelector } from '../../redux/selectorHooks';

export default () => {
  const dispatch = useAppDispatch();

  const { quickAccessDictionary } = useUserSettingsSelector('sidebarState');
  const { currentTab } = quickAccessDictionary;
  const activeIndices = quickAccessDictionary[currentTab].activeIndices ?? [];

  const onUpdateSettings = (
    newEntityTabType: EntityTabType,
    newIndices: number[],
  ) => {
    dispatch(
      setQuickAccessDictionarySetting({
        ...quickAccessDictionary,
        [newEntityTabType]: {
          activeIndices: newIndices,
        },
        currentTab: newEntityTabType,
      }),
    );
  };

  const toggleActiveIndex = (index: number) => {
    const newIndices = activeIndices.includes(index)
      ? activeIndices.filter((i) => i !== index)
      : [...activeIndices, index];

    onUpdateSettings(currentTab, newIndices);
  };

  const onChangeEntityType = (newEntityTabType: EntityTabType) => {
    const newIndices = quickAccessDictionary[newEntityTabType].activeIndices;
    onUpdateSettings(newEntityTabType, newIndices);
  };

  return {
    activeIndices,
    toggleActiveIndex,
    activeEntityType: currentTab,
    onChangeEntityType,
  };
};
